// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-cceef666]{font-size:.75rem;line-height:1.2;margin-top:12px;color:#ff8a00}", ""]);
// Exports
module.exports = exports;
